import {FC} from 'react';
import {Nav} from '../Nav';
import {PageLayoutProps} from './props';
import {Content} from './Content';
import {ContentContainer} from './ContentContainer';
import {PageTitle} from './PageTitle';
import {PageTitleActionAreaContainer} from './PageTitleActionAreaContainer';

export const SideNavigationLayout: FC<PageLayoutProps> = ({
    children,
    ...props
}) => (
    <ContentContainer
        hasSideNav
        isContained={props.isContained}
    >
        <PageTitleActionAreaContainer>
            {props.PageTitleProps && <PageTitle {...props.PageTitleProps}/>}
            {props.PageTitleActionAreaComponent}
        </PageTitleActionAreaContainer>
        <Nav {...props.SideNavProps}/>
        <Content>
            {children}
        </Content>
    </ContentContainer>
);

SideNavigationLayout.displayName = 'SideNavigationLayout';
